import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../App';
import { listenToRides } from '../firebase/database';

const NAV_ITEMS = [
  { icon: '⊞', label: 'Dashboard',  route: '/dashboard' },
  { icon: '🗺', label: 'Live Map',   route: '/map' },
  { icon: '🚗', label: 'Rides',      route: '/rides' },
  { icon: '👤', label: 'Drivers',    route: '/drivers' },
  { icon: '🧑‍💼', label: 'Customers', route: '/customers' },
  { icon: '📊', label: 'Reports',    route: '/reports' },
];

export default function AdminLayout({ children }) {
  const { logout, user } = useAuth();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [route, setRoute] = useState(window.location.hash.slice(1) || '/dashboard');

  useEffect(() => {
    const handler = () => {
      setRoute(window.location.hash.slice(1) || '/dashboard');
      setMobileNavOpen(false); // close nav on route change
    };
    window.addEventListener('hashchange', handler);
    return () => window.removeEventListener('hashchange', handler);
  }, []);

  const current = route;

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f8fafc', fontFamily: 'Inter, sans-serif' }}>
      <style>{`
        @media (max-width: 768px) {
          .desktop-sidebar { display: none !important; }
          .mobile-topbar { display: flex !important; }
          .main-content-pad { padding: 16px 16px !important; }
        }
        @media (min-width: 769px) {
          .desktop-sidebar { display: flex !important; }
          .mobile-topbar { display: none !important; }
          .mobile-nav-overlay { display: none !important; }
        }
      `}</style>

      {/* ── Desktop Sidebar ── */}
      <aside className="desktop-sidebar" style={{
        width: 220, minHeight: '100vh',
        background: '#0f172a', flexDirection: 'column',
        flexShrink: 0, position: 'sticky', top: 0, height: '100vh', overflowY: 'auto'
      }}>
        {/* Logo */}
        <div style={{
          padding: '20px', borderBottom: '1px solid #1e293b',
          display: 'flex', alignItems: 'center', gap: 10
        }}>
          <div style={{
            width: 34, height: 34, background: '#f59e0b', borderRadius: 8,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontWeight: 800, fontSize: 14, color: '#0f172a', flexShrink: 0
          }}>AK</div>
          <div>
            <div style={{ color: '#f1f5f9', fontWeight: 700, fontSize: 14, whiteSpace: 'nowrap' }}>
              AK Dispatching
            </div>
            <div style={{ color: '#64748b', fontSize: 11 }}>Admin Panel</div>
          </div>
        </div>

        {/* Nav */}
        <nav style={{ flex: 1, padding: '12px 0' }}>
          {NAV_ITEMS.map(item => {
            const active = current === item.route;
            return (
              <a key={item.route} href={`#${item.route}`} style={{
                display: 'flex', alignItems: 'center', gap: 12, padding: '11px 20px',
                color: active ? '#f59e0b' : '#94a3b8',
                background: active ? 'rgba(245,158,11,0.1)' : 'transparent',
                borderLeft: active ? '3px solid #f59e0b' : '3px solid transparent',
                textDecoration: 'none', fontSize: 14, fontWeight: active ? 600 : 400,
                transition: 'all 0.15s', whiteSpace: 'nowrap'
              }}>
                <span style={{ fontSize: 18, flexShrink: 0 }}>{item.icon}</span>
                {item.label}
              </a>
            );
          })}
        </nav>

        {/* User + Logout */}
        <div style={{ padding: '12px', borderTop: '1px solid #1e293b' }}>
          <div style={{
            color: '#64748b', fontSize: 12, marginBottom: 8,
            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
          }}>
            {user?.email}
          </div>
          <button onClick={logout} style={{
            width: '100%', padding: '8px 12px', background: 'transparent',
            border: '1px solid #1e293b', borderRadius: 6, color: '#ef4444',
            cursor: 'pointer', fontSize: 12, display: 'flex', alignItems: 'center', gap: 8
          }}>
            <span>⏻</span> Sign Out
          </button>
        </div>
      </aside>

      {/* ── Mobile Nav Overlay ── */}
      {mobileNavOpen && (
        <div
          className="mobile-nav-overlay"
          onClick={() => setMobileNavOpen(false)}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
            zIndex: 100, display: 'flex'
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              width: 240, height: '100%', background: '#0f172a',
              display: 'flex', flexDirection: 'column', overflowY: 'auto'
            }}
          >
            <div style={{
              padding: '20px', borderBottom: '1px solid #1e293b',
              display: 'flex', alignItems: 'center', justifyContent: 'space-between'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div style={{
                  width: 34, height: 34, background: '#f59e0b', borderRadius: 8,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontWeight: 800, fontSize: 14, color: '#0f172a'
                }}>AK</div>
                <div>
                  <div style={{ color: '#f1f5f9', fontWeight: 700, fontSize: 14 }}>AK Dispatching</div>
                  <div style={{ color: '#64748b', fontSize: 11 }}>Admin Panel</div>
                </div>
              </div>
              <button onClick={() => setMobileNavOpen(false)} style={{
                background: 'none', border: 'none', color: '#64748b', fontSize: 22, cursor: 'pointer'
              }}>×</button>
            </div>

            <nav style={{ flex: 1, padding: '12px 0' }}>
              {NAV_ITEMS.map(item => {
                const active = current === item.route;
                return (
                  <a key={item.route} href={`#${item.route}`} style={{
                    display: 'flex', alignItems: 'center', gap: 12, padding: '13px 20px',
                    color: active ? '#f59e0b' : '#94a3b8',
                    background: active ? 'rgba(245,158,11,0.1)' : 'transparent',
                    borderLeft: active ? '3px solid #f59e0b' : '3px solid transparent',
                    textDecoration: 'none', fontSize: 15, fontWeight: active ? 600 : 400,
                  }}>
                    <span style={{ fontSize: 20 }}>{item.icon}</span>
                    {item.label}
                  </a>
                );
              })}
            </nav>

            <div style={{ padding: '12px', borderTop: '1px solid #1e293b' }}>
              <div style={{ color: '#64748b', fontSize: 12, marginBottom: 8 }}>{user?.email}</div>
              <button onClick={logout} style={{
                width: '100%', padding: '10px 12px', background: 'transparent',
                border: '1px solid #1e293b', borderRadius: 6, color: '#ef4444',
                cursor: 'pointer', fontSize: 13, display: 'flex', alignItems: 'center', gap: 8
              }}>
                <span>⏻</span> Sign Out
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Main Content ── */}
      <main style={{ flex: 1, overflow: 'auto', minWidth: 0 }}>

        {/* Mobile Top Bar */}
        <header className="mobile-topbar" style={{
          display: 'none', background: '#0f172a',
          padding: '12px 16px', alignItems: 'center',
          justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 50
        }}>
          <button
            onClick={() => setMobileNavOpen(true)}
            style={{
              background: 'none', border: 'none', color: '#f1f5f9',
              fontSize: 22, cursor: 'pointer', padding: '4px 8px',
              display: 'flex', alignItems: 'center'
            }}
          >☰</button>
          <div style={{ color: '#f1f5f9', fontWeight: 700, fontSize: 16 }}>
            {NAV_ITEMS.find(n => n.route === current)?.label || 'Dashboard'}
          </div>
          <NotificationBell />
        </header>

        {/* Desktop Top Bar */}
        <header style={{
          background: '#fff', borderBottom: '1px solid #e2e8f0',
          padding: '16px 28px', display: 'flex', alignItems: 'center',
          justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 100
        }} className="desktop-topbar">
          <div>
            <div style={{ fontSize: 18, fontWeight: 700, color: '#0f172a' }}>
              {NAV_ITEMS.find(n => n.route === current)?.label || 'Dashboard'}
            </div>
            <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 2 }}>
              {new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
            </div>
          </div>
          <NotificationBell />
        </header>

        {/* Page content */}
        <div className="main-content-pad" style={{ padding: '24px 28px' }}>
          {children}
        </div>
      </main>
    </div>
  );
}

// ── Notification Bell with real Firestore listener ──
function NotificationBell() {
  const [rides, setRides] = useState([]);
  const [open, setOpen] = useState(false);
  const [readIds, setReadIds] = useState(() => {
    try { return JSON.parse(localStorage.getItem('ak_read_notifs') || '[]'); } catch { return []; }
  });
  const panelRef = useRef(null);

  useEffect(() => {
    const unsub = listenToRides((allRides) => {
      // Show notifications for: new pending rides + recently updated rides (last 24h)
      const cutoff = Date.now() - 24 * 60 * 60 * 1000;
      const relevant = allRides.filter(r => {
        const ts = r.updatedAt?.toDate?.()?.getTime() || r.createdAt?.toDate?.()?.getTime() || 0;
        return ts > cutoff;
      });
      setRides(relevant);
    });
    return unsub;
  }, []);

  // Close panel on outside click
  useEffect(() => {
    const handler = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const unreadCount = rides.filter(r => !readIds.includes(r.id)).length;

  const markAllRead = () => {
    const allIds = rides.map(r => r.id);
    setReadIds(allIds);
    localStorage.setItem('ak_read_notifs', JSON.stringify(allIds));
  };

  const markOneRead = (id) => {
    const updated = [...new Set([...readIds, id])];
    setReadIds(updated);
    localStorage.setItem('ak_read_notifs', JSON.stringify(updated));
  };

  const STATUS_COLORS = {
    pending:     { bg: '#fef9c3', color: '#854d0e', label: 'Pending' },
    assigned:    { bg: '#dbeafe', color: '#1e40af', label: 'Assigned' },
    accepted:    { bg: '#dcfce7', color: '#15803d', label: 'Accepted' },
    in_progress: { bg: '#e0e7ff', color: '#4338ca', label: 'In Progress' },
    completed:   { bg: '#f0fdf4', color: '#166534', label: 'Completed' },
    cancelled:   { bg: '#fee2e2', color: '#991b1b', label: 'Cancelled' },
  };

  return (
    <div ref={panelRef} style={{ position: 'relative' }}>
      {/* Bell button */}
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          position: 'relative', background: open ? '#f1f5f9' : 'transparent',
          border: '1px solid', borderColor: open ? '#e2e8f0' : 'transparent',
          borderRadius: 10, padding: '6px 10px', cursor: 'pointer',
          display: 'flex', alignItems: 'center', gap: 6, transition: 'all 0.15s'
        }}
      >
        <span style={{ fontSize: 20 }}>🔔</span>
        {unreadCount > 0 && (
          <div style={{
            position: 'absolute', top: 2, right: 2,
            background: '#ef4444', color: '#fff',
            minWidth: 18, height: 18, borderRadius: 9,
            fontSize: 11, fontWeight: 700, padding: '0 4px',
            display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>{unreadCount > 9 ? '9+' : unreadCount}</div>
        )}
      </button>

      {/* Dropdown Panel */}
      {open && (
        <div style={{
          position: 'absolute', right: 0, top: 44,
          width: 340, maxHeight: 480,
          background: '#fff', borderRadius: 14,
          border: '1px solid #e2e8f0',
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
          display: 'flex', flexDirection: 'column',
          zIndex: 9999, overflow: 'hidden'
        }}>
          {/* Header */}
          <div style={{
            padding: '14px 16px', borderBottom: '1px solid #f1f5f9',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            background: '#fff', flexShrink: 0
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontWeight: 700, fontSize: 15, color: '#0f172a' }}>Notifications</span>
              {unreadCount > 0 && (
                <span style={{
                  background: '#fef3c7', color: '#92400e', borderRadius: 20,
                  fontSize: 11, fontWeight: 700, padding: '2px 8px'
                }}>{unreadCount} new</span>
              )}
            </div>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              {unreadCount > 0 && (
                <button onClick={markAllRead} style={{
                  background: 'none', border: 'none', color: '#3b82f6',
                  fontSize: 12, cursor: 'pointer', fontWeight: 600
                }}>Mark all read</button>
              )}
              <button onClick={() => setOpen(false)} style={{
                background: '#f1f5f9', border: 'none', borderRadius: '50%',
                width: 26, height: 26, cursor: 'pointer', fontSize: 16,
                display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#64748b'
              }}>×</button>
            </div>
          </div>

          {/* List */}
          <div style={{ overflowY: 'auto', flex: 1 }}>
            {rides.length === 0 ? (
              <div style={{ padding: '32px 16px', textAlign: 'center', color: '#94a3b8', fontSize: 13 }}>
                <div style={{ fontSize: 28, marginBottom: 8 }}>✅</div>
                All caught up — no recent activity
              </div>
            ) : (
              rides.map(ride => {
                const isUnread = !readIds.includes(ride.id);
                const sc = STATUS_COLORS[ride.status] || { bg: '#f1f5f9', color: '#475569', label: ride.status };
                const dt = ride.updatedAt?.toDate?.() || ride.createdAt?.toDate?.();
                const timeStr = dt ? dt.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }) + ' · ' + dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : '';

                return (
                  <div
                    key={ride.id}
                    onClick={() => { markOneRead(ride.id); window.location.hash = '#/rides'; setOpen(false); }}
                    style={{
                      padding: '12px 16px', cursor: 'pointer',
                      background: isUnread ? '#fffbeb' : '#fff',
                      borderBottom: '1px solid #f8fafc',
                      transition: 'background 0.1s'
                    }}
                    onMouseOver={e => e.currentTarget.style.background = '#f8fafc'}
                    onMouseOut={e => e.currentTarget.style.background = isUnread ? '#fffbeb' : '#fff'}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      {isUnread && (
                        <div style={{ width: 7, height: 7, borderRadius: '50%', background: '#f59e0b', flexShrink: 0 }} />
                      )}
                      <div style={{
                        width: 34, height: 34, borderRadius: '50%', background: '#fef3c7',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontWeight: 700, fontSize: 13, color: '#92400e', flexShrink: 0
                      }}>
                        {ride.customerName?.charAt(0)?.toUpperCase() || '?'}
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <span style={{ fontWeight: 600, fontSize: 13, color: '#0f172a' }}>{ride.customerName}</span>
                          <span style={{
                            padding: '2px 8px', borderRadius: 20, fontSize: 10, fontWeight: 700,
                            background: sc.bg, color: sc.color
                          }}>{sc.label}</span>
                        </div>
                        <div style={{ fontSize: 12, color: '#64748b', marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          📍 {ride.pickupAddress}
                        </div>
                        <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>{timeStr}</div>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>

          {rides.length > 0 && (
            <div style={{ padding: '10px 16px', borderTop: '1px solid #f1f5f9', textAlign: 'center' }}>
              <a href="#/rides" onClick={() => setOpen(false)} style={{
                fontSize: 13, color: '#3b82f6', fontWeight: 600, textDecoration: 'none'
              }}>View all rides →</a>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
